import { z } from "zod";
import { OpaqueId } from "./common.js";
/**
 * Itinéraire de régulation nommé (CDC §5.2, §12.5bis, B5.2) — trajet
 * prédéfini entre deux carrefours, référence commune pour les régulateurs
 * (« fais du carrefour X au carrefour Y »). Donnée **gérée**
 * (`/admin/**`, pas encore construit) : en son absence, la liste est vide,
 * jamais devinée depuis le tracé GTFS.
 */
export const RegulationRoute = z.object({
    id: OpaqueId,
    lineId: OpaqueId,
    direction: z.union([z.literal(0), z.literal(1)]).nullable(),
    name: z.string(),
    /** Codes des carrefours traversés, dans l'ordre (voir `Junction.code`). */
    junctionCodes: z.array(z.string()),
    /** Toujours `true` sur la lecture publique (filtrée) ; utile côté admin (B7.1) pour voir un itinéraire désactivé. */
    active: z.boolean(),
});
export const RegRoutesResponse = z.object({ regRoutes: z.array(RegulationRoute) });
//# sourceMappingURL=regulation-route.js.map